import Biblioteca from '@/components/Repositorio/Biblioteca.js'

export default {
  async buscarDadosOrcamento(axios, parametros) {        
    parametros.operacao = 'buscarDadosOrcamento';
    let retorno = {};
    
    await axios.santriGET('/rest/orcamento', parametros, 15, true)
    .then(response => {
      retorno = Biblioteca.retornoRequisicao('N', undefined, response.data);
    })
    .catch(error => {
      retorno = Biblioteca.retornoRequisicao('S', error, undefined);
    })
    
    return retorno;
  },
}


// WEBPACK FOOTER //
// ./src/components/Rest/ROrcamento/ROrcamentoBuscarDadosOrcamento.js